// countries.js
export const countries = [
  { code: '+1', flag: '🇺🇸', name: 'United States', short: 'US' },
  { code: '+1', flag: '🇨🇦', name: 'Canada', short: 'CA' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom', short: 'UK' },
  { code: '+61', flag: '🇦🇺', name: 'Australia', short: 'AU' },
  { code: '+64', flag: '🇳🇿', name: 'New Zealand', short: 'NZ' },
  { code: '+49', flag: '🇩🇪', name: 'Germany', short: 'DE' },
  { code: '+33', flag: '🇫🇷', name: 'France', short: 'FR' },
  { code: '+39', flag: '🇮🇹', name: 'Italy', short: 'IT' },
  { code: '+34', flag: '🇪🇸', name: 'Spain', short: 'ES' },
  { code: '+31', flag: '🇳🇱', name: 'Netherlands', short: 'NL' },
  { code: '+41', flag: '🇨🇭', name: 'Switzerland', short: 'CH' },
  { code: '+46', flag: '🇸🇪', name: 'Sweden', short: 'SE' },
  { code: '+47', flag: '🇳🇴', name: 'Norway', short: 'NO' },
  { code: '+45', flag: '🇩🇰', name: 'Denmark', short: 'DK' },
  { code: '+358', flag: '🇫🇮', name: 'Finland', short: 'FI' },
  { code: '+353', flag: '🇮🇪', name: 'Ireland', short: 'IE' },
  { code: '+32', flag: '🇧🇪', name: 'Belgium', short: 'BE' },
  { code: '+351', flag: '🇵🇹', name: 'Portugal', short: 'PT' },
  { code: '+43', flag: '🇦🇹', name: 'Austria', short: 'AT' },
  { code: '+48', flag: '🇵🇱', name: 'Poland', short: 'PL' },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic', short: 'CZ' },
  { code: '+36', flag: '🇭🇺', name: 'Hungary', short: 'HU' },
  { code: '+40', flag: '🇷🇴', name: 'Romania', short: 'RO' },
  { code: '+7', flag: '🇷🇺', name: 'Russia', short: 'RU' },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine', short: 'UA' },
  { code: '+90', flag: '🇹🇷', name: 'Turkey', short: 'TR' },
  { code: '+971', flag: '🇦🇪', name: 'United Arab Emirates', short: 'AE' },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia', short: 'SA' },
  { code: '+20', flag: '🇪🇬', name: 'Egypt', short: 'EG' },
  { code: '+27', flag: '🇿🇦', name: 'South Africa', short: 'ZA' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria', short: 'NG' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya', short: 'KE' },
  { code: '+91', flag: '🇮🇳', name: 'India', short: 'IN' },
  { code: '+86', flag: '🇨🇳', name: 'China', short: 'CN' },
  { code: '+81', flag: '🇯🇵', name: 'Japan', short: 'JP' },
  { code: '+82', flag: '🇰🇷', name: 'South Korea', short: 'KR' },
  { code: '+65', flag: '🇸🇬', name: 'Singapore', short: 'SG' },
  { code: '+60', flag: '🇲🇾', name: 'Malaysia', short: 'MY' },
  { code: '+63', flag: '🇵🇭', name: 'Philippines', short: 'PH' },
  { code: '+62', flag: '🇮🇩', name: 'Indonesia', short: 'ID' },
  { code: '+66', flag: '🇹🇭', name: 'Thailand', short: 'TH' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam', short: 'VN' },
  { code: '+55', flag: '🇧🇷', name: 'Brazil', short: 'BR' },
  { code: '+54', flag: '🇦🇷', name: 'Argentina', short: 'AR' },
  { code: '+52', flag: '🇲🇽', name: 'Mexico', short: 'MX' },
  { code: '+56', flag: '🇨🇱', name: 'Chile', short: 'CL' },
  { code: '+57', flag: '🇨🇴', name: 'Colombia', short: 'CO' },
  { code: '+51', flag: '🇵🇪', name: 'Peru', short: 'PE' },
  // Add more as needed
];

// Sort alphabetically by country name
countries.sort((a, b) => a.name.localeCompare(b.name));